"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainMenuContainerComponent = MainMenuContainerComponent;
const React = __importStar(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const Guid = __importStar(require("@genesys/shared/lib/guid"));
const GlobalActions = __importStar(require("@genesys/client-core/lib/global-actions"));
const AuthorizationTools = __importStar(require("@genesys/shared/lib/authorization"));
const UserProfile = __importStar(require("@genesys/client-core/lib/user-profile"));
const ScreenAmountProfile = __importStar(require("@genesys/client-core/lib/screen-amount-profile"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const MainMenuView = __importStar(require("./main-menu-view"));
const Actions = __importStar(require("./actions"));
const queryProduct = (0, graphql_tag_1.default) `
  query MainMenuContainerProduct {
    product {
      languages {
        id
      }
    }
  }
`;
function MainMenuContainerComponent({ dispatch, isMainMenuActive, showProfileResetConfirmation }) {
    return (React.createElement(UserProfile.UserProfile, null, ({ applicationClaims, userName, resetUserSettings }) => (React.createElement(ScreenAmountProfile.ScreenAmountProfile, null, ({}) => (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProduct, variables: {} }, () => {
        const closeMenu = () => dispatch(Actions.closeMenu());
        const openDropdownMenu = (key) => dispatch(Actions.openRootNavItem(key));
        const onProfileResetAborted = () => {
            dispatch(Actions.toggleProfileResetConfirmationOff());
        };
        const onProfileResetConfirmed = () => {
            resetUserSettings();
            dispatch(Actions.toggleProfileResetConfirmationOff());
        };
        const openTab = (props) => {
            dispatch(GlobalActions.requestOpenTab({
                id: Guid.createGuid(),
                title: props.title,
                subject: props.subject
            }));
            dispatch(Actions.closeMenu());
        };
        const checkPermission = (claim, context) => AuthorizationTools.checkPermission(applicationClaims, claim, context);
        const hasPermission = (claim, value, context) => AuthorizationTools.hasPermission(applicationClaims, claim, value, context);
        return (React.createElement(MainMenuView.MainMenuView, { checkPermission: checkPermission, hasPermission: hasPermission, closeMenu: closeMenu, openDropdownMenu: openDropdownMenu, isMainMenuActive: isMainMenuActive, userName: userName, openTab: openTab, showProfileResetConfirmation: showProfileResetConfirmation, onProfileResetAborted: onProfileResetAborted, onProfileResetConfirmed: onProfileResetConfirmed }));
    }))))));
}
//# sourceMappingURL=container-component.js.map